import React, { FC } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import classes from "./Loading.module.scss";
import { loadingState, loadingText } from "../../../states/LoadingState.js";
import { useRecoilValue } from "recoil";

const Loading = ({ children }) => {
  const isBeingLoaded = useRecoilValue(loadingState);
  const displayText = useRecoilValue(loadingText);

  return (
    <>
      {isBeingLoaded && (
        <section className={classes.section__loading}>
          <CircularProgress sx={{ color: "#09a0f2" }} />
          <p>{displayText}</p>
        </section>
      )}
      {children}
    </>
  );
};

export default Loading;
